import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import api from "../lib/api";
import { useI18n } from "../i18n/I18nContext";
import { Check, Loader2 } from "lucide-react";

export default function CheckoutSuccess() {
  const { t, routes } = useI18n();
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    if (!sessionId) { setStatus("done"); return; }
    let attempts = 0, timer;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/checkout/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.status === "expired") { setStatus("expired"); return; }
        if (attempts < 6) timer = setTimeout(poll, 2000);
        else setStatus("pending");
      } catch {
        if (attempts < 6) timer = setTimeout(poll, 2000);
        else setStatus("error");
      }
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId]);

  return (
    <div data-testid="checkout-success-page">
      <Header />
      <main className="bg-white">
        <div className="max-w-3xl mx-auto px-5 lg:px-8 py-20 lg:py-28">
          {status === "checking" && (
            <div className="flex items-center gap-3 text-slate-700">
              <Loader2 size={20} className="animate-spin" />
              <span className="text-sm">{t.success.checking}</span>
            </div>
          )}
          {(status === "paid" || status === "done") && (
            <>
              <div className="w-14 h-14 bg-emerald-600 rounded-md flex items-center justify-center mb-6">
                <Check size={28} className="text-white" strokeWidth={3} />
              </div>
              <p className="eyebrow text-emerald-700 mb-3">OK</p>
              <h1 className="font-display font-bold text-4xl sm:text-5xl tracking-tight leading-[1.05]">{t.success.title}</h1>
              <p className="mt-5 text-slate-600 max-w-xl leading-relaxed">{t.success.lead}</p>
              <Link to={routes.home} className="btn-primary mt-8 inline-flex">{t.success.back}</Link>
            </>
          )}
          {(status === "pending" || status === "expired" || status === "error") && (
            <>
              <h1 className="font-display font-bold text-3xl tracking-tight">…</h1>
              <p className="mt-5 text-slate-700">{status}</p>
              <Link to={routes.home} className="btn-secondary mt-8 inline-flex">{t.success.back}</Link>
            </>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
